var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-vue-table',{ref:"GVueTable",attrs:{"apiIndexUrl":_vm.detailsURL,"sortBy":"email","columns":_vm.columns,"filtered":false,"creable":false,"obj":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }